'use strict';

export const VOYADO_EVENT_MONITOR_CART = 'Voyado-monitor-cart';
export const VOYADO_EVENT_MONITOR_EMPTY_CART = 'Voyado-monitor-empty-cart';
export const VOYADO_EVENT_TRACK_PRODUCT_IMPRESSION = 'Voydo-monitor-product-impression';
export const VOYADO_SCRIPT_LOADED = 'Voyado-script-loaded';
export const VOYADO_INITIALIZE = 'voyado:initialize';
